





















import { Vue, Component } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import { RootState } from '@/store';
import { DataListItem, DataViewItem, SubregisterData } from '@/types';
import { DataManagementState } from '@/store/modules/dataManagement';
import { findInDataByRegisterId } from '@/utils/statementObjectData';

@Component({name: 'SubregistersCard'})
export default class extends Vue {

  @State((state: RootState) => state.dataManagement.currentDataViewItem)
  private viewItemData!: DataViewItem;

  @State((state: RootState) => state.dataManagement.content)
  private allDataContent!: DataListItem[] & DataManagementState['content'];

  @Getter('dataManagement/themeColor')
  private themeColor!: CSSStyleDeclaration['color'];

  @Getter('dataManagement/cardBgColor')
  private cardBgColor!: CSSStyleDeclaration['color'];

  private renderSubregisterView(subregisterId: SubregisterData['id']): void {
    const dataViewItem: DataViewItem | undefined = findInDataByRegisterId(subregisterId, this.allDataContent);
    if (dataViewItem) {
      this.renderDataViewItem(dataViewItem[0], 0);
    }
  }

  private renderDataViewItem(dataList: DataViewItem, index: number): void {
    this.$store.commit('dataManagement/SET_CURRENT_DATA_VIEW_ITEM', dataList || {});
    if (index !== undefined) {
      this.$store.commit('dataManagement/ADD_NAVIGATED_LIST_INDEX', index);
    }
  }
}
